module.exports = __webpack_public_path__ + "img/556C83C5A2DD1C30A379FA7A5925E426.556c83c5.png";